var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.701904 0.587158H29.0192V18.4129H0.701904V0.587158Z",
    fill: "#11457E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0192 9.5V18.4129H0.701904L12.6032 9.5H29.0192Z",
    fill: "#D7141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0192 0.587158V9.50002H12.6032L0.701904 0.587158H29.0192Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_538"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.701904,
    y: 0.586914,
    width: 28.3173,
    height: 17.8261,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCz);
export default __webpack_public_path__ + "static/media/cz.1c999b921418a91c941f8b58a74deb72.svg";
export { ForwardRef as ReactComponent };